import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import { PASearch, ISearchRequest } from "../PA.Core/PASearch";
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import * as _ from "lodash";


const vUI_Product_Condition_Type_Search_Fields: { [id: string]: ISearchProviderField } = {
    PRD_CNDM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: "Id", columnResourceName: "colId", alignment: HorizAlignment.Right },
        domainOptions: {}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Master Data Set",
            columnResourceName: "colMDSetWbId",
            alignment: HorizAlignment.Right
        },
        domainOptions: {}
    },
    MDSET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Master Data Set Id",
            columnResourceName: "colMDSetId",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Master Data Set",
            columnResourceName: "colMDSetName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true }
    },
    SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Key Set", columnResourceName: "colSetId", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    SET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Key Set Name", columnResourceName: "colSetName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true }
    },
    CONDITION_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Condition Type ID",
            columnResourceName: "colConditionId",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    CONDITION_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Condition Type Name",
            columnResourceName: "colName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    RESERVED_TERM_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Term ID", columnResourceName: "colTermId", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50, domainIds: "POLICY_RESERVED_TERM", useIdAsKey: true }
    },
    DIMENSIONS: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Dimensions",
            columnResourceName: "colDimensions",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    COUNTS: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: "# Conditions", columnResourceName: "colCounts", alignment: HorizAlignment.Right },
        domainOptions: {}
    },
    POLICYAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Policy Area ID", columnResourceName: "colPAId", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    POLICYAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Policy Area Name",
            columnResourceName: "colPAName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true }
    },
    POLICY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Policy Id", columnResourceName: "colPolicyId", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    POLICY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Policy", columnResourceName: "colPolicyName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256, bUseSearchProvidersDistinctValues: true }
    }

};


const TermConditionEditorSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: "PRD_CNDM_ID",
        id_ui: "CONDITION_TYPE",
        name: "CONDITION_TYPE_NAME"
    },


    searchProviderFields: vUI_Product_Condition_Type_Search_Fields,

    async search(searchOptions: ISearchRequestSubset): Promise<any[]> {


        let findRequest = SearchUtils.makeSearchRequest(searchOptions,
            "vUI_TermConditionEditor_Search",
            this.searchProviderFields,
            []);

        return await PASearch.findByRequest(findRequest);
    },
    async distinctValues(fieldName: string): Promise<string[] | number[]> {


        let findRequest = SearchUtils.makeSearchRequest({},
            "vUI_TermConditionEditor_Search",
            this.searchProviderFields,
            [fieldName]);


        let res = await PASearch.findByRequest(findRequest);

        return _.map(res, (aRow) => {
            return aRow[fieldName];
        });
    }
};


const TermConditionEditorSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "TermConditionEditorSearchProfileByName" },


    profileFilter: [
        {
            profileFilterName: "Master Data Set",
            searchProviderFieldId: "MDSET_NAME",
            bMultiSelect: true,
            renderOptions: {}
        },
        { profileFilterName: "Policy", searchProviderFieldId: "POLICY_NAME", bMultiSelect: true, renderOptions: {} },
        { profileFilterName: "Key Set", searchProviderFieldId: "SET_NAME", bMultiSelect: true, renderOptions: {} },
        { profileFilterName: "Term", searchProviderFieldId: "RESERVED_TERM_ID", bMultiSelect: true, renderOptions: {} },
        { profileFilterName: "Condition Type ID", searchProviderFieldId: "CONDITION_TYPE", renderOptions: {} }
    ],  // ISearchFields
    profileDisplayFields: [
        "MDSET_NAME", "SET_NAME",  "CONDITION_TYPE", "CONDITION_TYPE_NAME", "RESERVED_TERM_ID", "DIMENSIONS", "COUNTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)
    profileHiddenFields: [],
    profileSearchProvider: TermConditionEditorSearchProviderBasic,

    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};


let TermConditionEditorSearch: ISearch = {
    searchName: "Find Product Condition Type",
    renderOptions: { ui5ResourceId: "TermConditionEditorSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [TermConditionEditorSearchProfileByName],
    autoSearch: true
};

PAEnvironment.registerBusinessObjectSearch("ProductConditionTypeBO", "TermConditionEditor", TermConditionEditorSearch, "Term Condition Editor Search");

export { TermConditionEditorSearch };